export const adminPrefix = '/admin'
export const sellerPrefix = '/seller'
export const clientPrefix = '/client'
export const providerPrefix = '/sales-rep'
